import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyTitleComponent } from './survey-title.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';
import { NgModelOptionsModule } from '../../../shared/directives/ng-model-options';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule, NgModelOptionsModule,
    AutosizeModule,
  ],
  declarations: [SurveyTitleComponent],
  exports: [SurveyTitleComponent],
})
export class SurveyTitleModule { 
}
